export default "__VITE_ASSET__D2OXF8MO__"